(function () {
  function dispatchNativeGFEvent(name, detail) {
    document.dispatchEvent(new CustomEvent(name, { detail }));
  }

  function hookGravityFormsEvents() {
    // If GF/jQuery is present, bridge GF events into native events
    if (window.jQuery) {
      window.jQuery(document).on("gform_post_render gform_page_loaded", function (e, formId, currentPage) {
        dispatchNativeGFEvent("gf:post_render", { formId, currentPage });
        dispatchNativeGFEvent("gf:page_loaded", { formId, currentPage });
      });
    }

    // Also run once on initial load for non-AJAX initial render
    document.querySelectorAll("form[id^='gform_']").forEach((f) => {
      const m = f.id.match(/^gform_(\d+)$/);
      if (m) dispatchNativeGFEvent("gf:post_render", { formId: parseInt(m[1], 10), currentPage: null });
    });
  }

  function applyRequiredUI(formEl, makeRequired) {
    const targets = formEl.querySelectorAll(".gfield.req_if_compliance");

    targets.forEach((fieldWrap) => {
      fieldWrap.classList.toggle("is-required-by-compliance", makeRequired);

      const label = fieldWrap.querySelector(".gfield_label");
      if (label) {
        let reqSpan = label.querySelector(".gfield_required.compliance-required");
        if (makeRequired) {
          if (!reqSpan) {
            reqSpan = document.createElement("span");
            reqSpan.className = "gfield_required compliance-required";
            reqSpan.setAttribute("aria-hidden", "true");
            reqSpan.textContent = " *";
            label.appendChild(reqSpan);
          }
        } else if (reqSpan) {
          reqSpan.remove();
        }
      }

      fieldWrap.querySelectorAll("input, select, textarea").forEach((input) => {
        if (!input.name) return;
        if (makeRequired) {
          input.setAttribute("aria-required", "true");
          input.setAttribute("required", "required");
        } else {
          input.removeAttribute("aria-required");
          input.removeAttribute("required");
        }
      });
    });
  }

  function initForForm(formId) {
    const formEl = document.querySelector(`#gform_${formId}`);
    if (!formEl) return;

    const trigger = formEl.querySelector(".gfield.compliance_only_trigger input[type='checkbox']");
    if (!trigger) return;

    const update = () => applyRequiredUI(formEl, !!trigger.checked);

    // Avoid stacking listeners on AJAX re-render
    if (!trigger.dataset.complianceListenerAttached) {
      trigger.addEventListener("change", update);
      trigger.dataset.complianceListenerAttached = "1";
    }

    update();
  }

  function boot() {
    // Vanilla listeners
    document.addEventListener("gf:post_render", (e) => initForForm(e.detail.formId));
    document.addEventListener("gf:page_loaded", (e) => initForForm(e.detail.formId));

    hookGravityFormsEvents();
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", boot);
  } else {
    boot();
  }
})();